 <!-- 我的优惠券 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的优惠券</p>
      </div>
      <div>
        <el-button style="background-color: #ff821c" size="small" type="warning" round @click="dialogFormVisible = true">券码兑换</el-button>
        <!-- <el-button class="buttons" size="small" @click="dialogFormVisible2 = true" round>申请优惠</el-button> -->
        <el-button class="buttons" size="small" @click="applyYouhui" round>申请优惠</el-button>
      </div>
    </div>
    <div class="nav-list">
      <ul>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">可用</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">已用</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==3?'cur':''" @click="onCur(3)">已过期</li>
      </ul>
    </div>
    <div class="coupon-item">
      <ul class="coupon-item-ul">
        <li class="coupon-item-ul-li" v-for="item,index in orderList" :key="index" :class="type==3?'coupon-item-ul-lis':''">
          <p class="coupon-item-ul-li-type" v-if="type==1">可用</p>
          <p class="coupon-item-ul-li-type" v-else-if="type==2">已用</p>
          <p class="coupon-item-ul-li-type coupon-item-ul-li-types" v-else>已过期</p>
          <div class="coupon-item-ul-li-title" :class="type==3?'coupon-item-ul-li-titles':''">
            <p class="coupon-item-ul-li-title-discount" :class="type==3?'coupon-item-ul-li-title-discounts':''">{{item.discountRatio*10}}<span>折</span></p>
            <div>
              <p class="coupon-item-ul-li-title-name">{{item.couponName}}</p>
              <p class="coupon-item-ul-li-title-time" :class="type==3?'coupon-item-ul-li-title-times':''">{{item.createTime.split(" ")[0]}} - {{item.expireTime.split(" ")[0]}}</p>
            </div>
          </div>
          <div class="coupon-item-ul-li-content">
            <p>券类型：{{item.type==0?'通用':(item.type==1?'课程券':'考试券')}}</p>
						<!-- <p>限制使用：{{item.type==0?'通用':(item.type==1?'所有课程':'所有考试')}}</p> -->
						<p>限制人员：{{item.userLimit?'指定人员':'所有人'}}</p>
            <p style="margin-bottom: 0">券编号：{{item.couponNum}}</p>
          </div>
          <div style="text-align: center;margin-top: 10px" v-if="type==1">
            <el-button style="background-color: #ff821c" size="small" type="warning" @click="onCoupon(item.type)">立即使用</el-button>
          </div>
        </li>
        <!-- <li class="coupon-item-ul-li" :class="type==3?'coupon-item-ul-lis':''">
          <p class="coupon-item-ul-li-type" v-if="type==1">可用</p>
          <p class="coupon-item-ul-li-type" v-else-if="type==2">已用</p>
          <p class="coupon-item-ul-li-type coupon-item-ul-li-types" v-else>已过期</p>
          <div class="coupon-item-ul-li-title" :class="type==3?'coupon-item-ul-li-titles':''">
            <p class="coupon-item-ul-li-title-discount" :class="type==3?'coupon-item-ul-li-title-discounts':''">9<span>折</span></p>
            <div>
              <p class="coupon-item-ul-li-title-name">新人券</p>
              <p class="coupon-item-ul-li-title-time" :class="type==3?'coupon-item-ul-li-title-times':''">2024/08/05-2024/11/05</p>
            </div>
          </div>
          <div class="coupon-item-ul-li-content">
            <p>券类型：课程券</p>
            <p>限制使用：所有课程</p>
            <p>限制人员：所有人</p>
            <p style="margin-bottom: 0">券编号：445464654545</p>
          </div>
          <div style="text-align: center;margin-top: 10px" v-if="type==1">
           <el-button size="small" type="warning">立即使用</el-button>
          </div>
        </li> -->
      </ul>
    </div>
    <!-- <el-pagination
      background
      layout="prev, pager, next"
      :total="100">
    </el-pagination> -->

    <div class="popup">
      <!-- 报名 -->
      <el-dialog title="" :visible.sync="dialogFormVisible">
        <p class="popup-title">券码兑换</p>
        <div class="popup-form">
          <el-form label-position="top" label-width="80px" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="兑换卡号：" prop="code">
              <el-input v-model="ruleForm.code" placeholder="请输入卡号"></el-input>
            </el-form-item>
            <el-form-item label="密钥：" prop="secret">
              <el-input v-model="ruleForm.secret" placeholder="请输入卡密"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button size="small" type="warning" @click="submitForm('ruleForm')" style="padding: 12px 80px;background-color: #ff821c">立即兑换</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>

      <el-dialog title="" :visible.sync="dialogFormVisible2">
        <p class="popup-title">申请理由</p>
        <div class="popup-form">
          <el-form label-position="top" label-width="80px" :model="form" :rules="rules" ref="form" class="demo-ruleForm">
            <el-form-item label="申请理由：" prop="reason">
              <el-input type="textarea" v-model="form.reason" placeholder="请输入申请理由"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button size="small" type="warning" @click="couponsList('form')" style="padding: 12px 80px;background-color: #ff821c">立即申请</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { myCoupons,couponActive,couponsList,couponApply,userInfo } from '../../api/userMG'
export default {
  data() {
    return {
      type:1,
      orderList:[],
      dialogFormVisible:false,
      dialogFormVisible2:false,
      ruleForm:{
        code: '',
        secret: '',
      },
      form:{
        reason:''
      },
      rules: {
        code: [
          { required: true, message: '请输入卡号', trigger: 'blur' }
        ],
        secret: [
          { required: true, message: '请输入卡密', trigger: 'blur' }
        ],
        reason:[
          { required: true, message: '请输入申请理由', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getCoupons();
  },
  methods:{
    onCur(e){
      this.type = e;
      this.orderList = []
      this.getCoupons()
    },
    // 我的优惠券列表
    getCoupons(){
      let params = {
        status:this.type-1,
      }
      // const loading = this.$loading({
      //   lock: true,
      //   text: '加载中',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      myCoupons(params).then(res => {
        console.log('优惠券数据',res);
        // this.total = res.data.total;
        this.orderList = res.data;
        // loading.close();
      })
      // .catch(err => {
      //   loading.close();
      // })
    },
    
    // 申请优惠
    applyYouhui(){
        userInfo().then(res => {
          console.log('用户信息-优惠券',res);
          if(!res.data.certificateUser){
              this.$message({
                message: '请进行身份认证后再次操作！',
                type: 'warning',
                offset:100
              })
              setTimeout(() => {
                this.$router.push({path:'/personal/personal'})
              }, 2000);
          }else{
              this.dialogFormVisible2 = true
          }
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          couponActive(this.ruleForm).then(res => {
            console.log('优惠券兑换',res);
            if(res.code == 0){
              this.$message({
                message: res.msg,
                type: 'success',
                offset:100
              });
              this.getCoupons();
              this.dialogFormVisible = false;
              this.ruleForm.code='';
              this.ruleForm.secret='';
            }
          })
        }
      });
    },

    couponsList(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          let reason = this.form.reason;
          console.log('开始兑换',reason);
          couponApply({reason:reason}).then(res => {
            console.log('申请优惠券',res);
            this.dialogFormVisible2 = false;
            if(res.code == 0){
              this.$message({
                message:'已申请',
                type: 'success',
                offset:100
              });
            }else{
              this.$message({
                message:res.msg,
                type: 'success',
                offset:100
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },
    onCoupon(type){
      if(type==1){
        this.$router.push({path:'/index/classroom'})
      }else{
        this.$router.push({path:'/index/exam'})
      }
    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 12px;
    /* margin:  0 10px; */
    cursor: pointer;
  }
  .divider{
    margin:  0 10px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  
  .coupon-item{
    margin-top: 30px;
  }
  .coupon-item-ul{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .coupon-item-ul-li{
    border: 1px solid #fbf0e4;
    border-radius: 6px;
    width: 27.3%;
    padding: 0 16px 14px;
    background-image: linear-gradient(bottom,#fbf0e4,#fff9f1);
    margin-right: 12px;
    margin-bottom: 12px;
  }
  .coupon-item-ul-lis{
    border: 1px solid #efefef;
    background-image: linear-gradient(bottom,#efefef,#f7f7f5);
  }
  .coupon-item-ul-li:nth-child(3), .coupon-item-ul-li:nth-child(6), .coupon-item-ul-li:nth-child(9) {
    margin-right: 0;
  }
  .coupon-item-ul-li-type{
    width: 90px;
    height: 24px;
    background: #ffdfb9;
    color: #f15c04;
    font-size: 13px;
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin:0 auto 10px;
  }
  .coupon-item-ul-li-types{
    background: #cccccc;
    color: #676767;
  }
  .coupon-item-ul-li-title{
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px dotted #fcd5bb;
    padding-bottom: 6px;
  }
  .coupon-item-ul-li-titles{
    border-bottom: 1px dotted #e5e5e5;
  }
  .coupon-item-ul-li-title-discount{
    font-size: 34px;
    color: #f15c04;
    margin-right: 20px;
  }
  .coupon-item-ul-li-title-discounts{
    color: #989898;
  }
  .coupon-item-ul-li-title-discount span{
    font-size: 14px;
  }
  .coupon-item-ul-li-title-name{
    font-size: 14px;
    color: black;
  }
  .coupon-item-ul-li-title-time{
    font-size: 11px;
    color: #f15c04;
  }
  .coupon-item-ul-li-title-times{
    color: #a1a1a1;
  }
  .coupon-item-ul-li-content{
    padding: 10px 10px 0;
  }
  .coupon-item-ul-li-content p{
    font-size: 10px;
    color: #686666;
    margin-bottom: 5px;
  }


  .popup /deep/ .el-dialog__header{
    padding: 0;
  }
  .popup /deep/ .el-dialog__body{
    padding: 0;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
    font-size: 19px;
  }
   .popup /deep/ .el-dialog{
    border-radius: 8px;
  }
  .popup /deep/ .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }

  .popup-title{
    background: #ff821e;
    color: #fff;
    font-size: 16px;
    padding: 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .popup-form{
    padding: 40px 110px;
  }

  .el-button--small {
    padding: 7px 20px;
  }
 
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .el-pagination{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/coupon/coupon.vue